import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=3efb9b04&scoped=true&"
import script from "./ClaimDetail.vue?vue&type=script&lang=js&"
export * from "./ClaimDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetail.vue?vue&type=style&index=0&id=3efb9b04&lang=scss&scoped=true&"
import style1 from "./ClaimDetail.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ClaimDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb9b04",
  null
  
)

export default component.exports